import { BuildInfo } from "@prism/prism-shared"; 
        
export const buildInfo: BuildInfo = { 
    commitHash: 'd01a864b28645901ebadb805ebb57fe1eb60cd1d', 
    deploymentTimestamp: 1793765379962,
    user: 'steven woerpel',
    deploymentId: 'd01a864b-mw1llda2',
}
